var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 50,
    viewBox: "0 0 95 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_78",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_79",
    x: 45,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8735",
    "data-name": "Group 8735",
    transform: "translate(-231.723 -572)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 231.72, 572)",
    filter: "url(#Ellipse_78)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78-2",
    "data-name": "Ellipse 78",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(9 6)",
    fill: "#f6f8fb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 231.72, 572)",
    filter: "url(#Ellipse_79)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79-2",
    "data-name": "Ellipse 79",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(54 6)",
    fill: "#f6f8fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M17.51,15a11.262,11.262,0,0,0-2.352-1.574c-.705-.339-.963-.332-1.462.028-.415.3-.684.579-1.162.475A6.934,6.934,0,0,1,10.2,12.2,6.884,6.884,0,0,1,8.47,9.866c-.1-.482.178-.747.475-1.162.36-.5.37-.757.028-1.462A11.039,11.039,0,0,0,7.4,4.889c-.513-.513-.628-.4-.911-.3a5.184,5.184,0,0,0-.834.443,2.516,2.516,0,0,0-1,1.058c-.2.429-.429,1.229.743,3.316a18.5,18.5,0,0,0,3.253,4.339h0l0,0,0,0h0A18.574,18.574,0,0,0,12.994,17c2.087,1.173,2.887.942,3.316.743a2.474,2.474,0,0,0,1.058-1,5.184,5.184,0,0,0,.443-.834C17.912,15.629,18.027,15.513,17.51,15Z",
    transform: "translate(245.705 582.198)",
    fill: "#7648a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-message",
    "data-name": "Icon material-message",
    d: "M16.026,3H4.447a1.445,1.445,0,0,0-1.44,1.447L3,17.473l2.895-2.895H16.026a1.452,1.452,0,0,0,1.447-1.447V4.447A1.452,1.452,0,0,0,16.026,3Zm-1.447,8.684H5.895V10.237h8.684Zm0-2.171H5.895V8.066h8.684Zm0-2.171H5.895V5.895h8.684Z",
    transform: "translate(291.486 583.763)",
    fill: "#7648a3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8189c7e54d7b75dfaf04e15b247403ac.svg";
export { ForwardRef as ReactComponent };